"use strict";

/**
 * @classdesc
 * Container zur Verwaltung der featurebasierten Abfrage-Ergebnisse pro Layer innerhalb der Sidebar.
 *
 * @class
 * @extends gc.gis.module.GCFeatureInfo.AbstractFeatureResultList
 * @memberof gc.gis.module.GCFeatureInfo
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 */
gc.gis.module.GCFeatureInfo.FeatureResultListSidebar = function()
{
    gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.call(this);

    /**
     * Container für die Liste der Features
     * @type {gc.gis.widget.GCList}
     * @private
     */
    this._feature_container = null;

	/**
	 * FE-Flag.
	 * @type {boolean}
	 */
	this.fe = gc.gis.iface.fe;

    // Elemente erzeugen und Hauptcontainer initialisieren
    this._render();
};
gc.gis.module.GCFeatureInfo.FeatureResultListSidebar.prototype = Object.create(gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype);

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.FeatureResultListSidebar.prototype._render = function()
{
    this._feature_container = new gc.gis.widget.GCList({
        className: this.className,
        listType: gc.gis.widget.GCListType.LINKED
    });

    return this._feature_container.getElement();
};

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.FeatureResultListSidebar.prototype.setFeatureDetail = function (layer, feature, content, contentType)
{
    // do nothing
};

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.FeatureResultListSidebar.prototype._createFeatureItem = function (layer, feature)
{
    var self = this;
    var label = feature.getAttribute('title') || 'Objekt';

	// Aktionen
	var btn_group = new gc.gis.widget.GCWidgetGroup({
		containerClassName: 'gc-feature-actiongroup'
	});

    var item = this._feature_container.addItem(label, {
        click: function(index, evt) {
            evt.preventDefault();   // Link nicht öffnen
	        // Prüfung, ob wirklich auf das Item oder einem Button geklickt wurde
	        // => stopPropagation funktioniert leider auf Grund Dropdown-Menü am Button nicht
	        if (self._feature_container.getItem(index).get(0) === evt.target)
	        {
		        self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_CLICK, {
			        layer: layer,
			        feature: feature
		        });
	        }
            return false;
        },
        enter: function(index, evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSEENTER, {
                layer: layer,
                feature: feature
            });
        },
        leave: function(index, evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSELEAVE, {
                layer: layer,
                feature: feature
            });
        }
    });

    // im Frontendmodus nur den Zoombutton anzeigen, dort gibt es bislang keine weiteren Aktionen
	if (!this.fe)
	{
		var action_menu = new gc.gis.widget.GCMenu({
			label: 'Aktionen',
			className: 'gc-feature-action',
			direction: 'right',
			icon: 'glyphicon glyphicon-option-vertical',
			containerClassName: 'gc-feature-actionmenu'
		});
		btn_group.addItem(action_menu);

		// Standardaktionen
		action_menu.addItem(new gc.gis.widget.GCItem({
			label: 'Zum Objekt zoomen',
			click: function(evt) {
				self._doFeatureZoom(layer, feature);
			}
		}));

		// featurespezifische Aktionen
		var featureActions = feature.getAttribute('actions');
		var btn_action;
		for (var i=0; i<featureActions.length; i++)
		{
			btn_action = new gc.gis.widget.GCItem({
				label: featureActions[i].caption,
				action: gc.gis.action.GCServerSideActionFactory.createAction(featureActions[i])
			});
			action_menu.addItem(btn_action);
		}
	}
	else
	{
		// Zoom-Button
		var btn_zoom = new gc.gis.widget.GCItem({
			label: 'Zum Objekt zoomen',
			className: 'gc-feature-action',
			icon: 'ms ms-zoom-to-extent',
			click: function(evt) {
				self._doFeatureZoom(layer, feature);
			}
		});

		btn_group.addItem(btn_zoom);
	}

	if (btn_group.numItems() > 0) {
		item.append(btn_group.getElement());
	}

    return item;
};
